import React from 'react'

export const IconSettings: React.FC = () => {
  return (
    <svg width="33" height="35" viewBox="0 0 33 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.0355 7H31V10H18.0355V7ZM2 10H12V13H15L15.0415 4H12V7H2V10ZM12 25H31V28H12V25ZM27 16H31V19H27V16ZM24 22V13H21V16H2V18.9583H21V22H24ZM9 31V22H6V25H2V28H6V31H9Z" />
    </svg>
  )
}
